import { render, staticRenderFns } from "./PaymentsUser.vue?vue&type=template&id=5a1da5e2&"
import script from "./PaymentsUser.vue?vue&type=script&lang=js&"
export * from "./PaymentsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports